export default "__VITE_ASSET__DoAe1q_$__"